import { Language } from '../app/shared/components/language-selector/language.model';
import { environment } from '../environments/environment';

export const AvailableLanguages: Language[] = [
  { code: 'en', i18nKey: 'languages.english', flag: 'https://restcountries.com/data/usa.svg', isActive: true },
  { code: 'de', i18nKey: 'languages.german', flag: 'https://restcountries.com/data/deu.svg', isActive: true },
  { code: 'en-gb', i18nKey: 'languages.english', flag: 'https://restcountries.com/data/gbr.svg', isActive: true },
  { code: 'zh-hk', i18nKey: 'languages.chinese', flag: 'https://restcountries.com/data/hkg.svg', isActive: true },
  { code: 'fr', i18nKey: 'languages.french', flag: 'https://restcountries.com/data/fr.svg', isActive: environment.feature.frit },
  { code: 'it', i18nKey: 'languages.Italian', flag: 'https://restcountries.com/data/it.svg', isActive: environment.feature.frit },
  // { code: 'ja', i18nKey: 'languages.japanese', flag: 'https://restcountries.com/data/jpn.svg' },
];
